import { FC } from 'react';

type Props = {
};

const RetroCollectionIcon: FC<Props> = ({}) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M7.62134 1.56323C8.02208 1.56333 8.36872 1.84266 8.45435 2.23413L10.1672 10.074H17.4553C18.1039 10.0741 18.63 10.6002 18.6301 11.2488V13.7048L19.4436 21.0242C19.4956 21.4919 19.1584 21.914 18.6907 21.9666C18.2223 22.019 17.8004 21.6811 17.7483 21.2126L17.5266 19.2175H7.09986L6.56763 21.7585C6.47119 22.2198 6.01901 22.5153 5.55787 22.4187C5.09734 22.3219 4.80247 21.8706 4.89869 21.4099L6.5022 13.7371L4.56373 2.56226C4.47352 2.04088 4.87532 1.56323 5.40455 1.56323H7.62134ZM7.4563 17.5125H17.3372L17.0178 14.6404H8.05689L7.4563 17.5125Z" fill="#9C752C"/>
</svg>
);

export default RetroCollectionIcon;import { FC } from 'react';

type Props = {
};

const RetroCollectionIcon: FC<Props> = ({}) => (
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M7.62134 1.56323C8.02208 1.56333 8.36872 1.84266 8.45435 2.23413L10.1672 10.074H17.4553C18.1039 10.0741 18.63 10.6002 18.6301 11.2488V13.7048L19.4436 21.0242C19.4956 21.4919 19.1584 21.914 18.6907 21.9666C18.2223 22.019 17.8004 21.6811 17.7483 21.2126L17.5266 19.2175H7.09986L6.56763 21.7585C6.47119 22.2198 6.01901 22.5153 5.55787 22.4187C5.09734 22.3219 4.80247 21.8706 4.89869 21.4099L6.5022 13.7371L4.56373 2.56226C4.47352 2.04088 4.87532 1.56323 5.40455 1.56323H7.62134ZM7.4563 17.5125H17.3372L17.0178 14.6404H8.05689L7.4563 17.5125Z" fill="#9C752C"/>
</svg>
);

export default RetroCollectionIcon;